import { Button } from '../../components/button'
import { DashboardWrapper } from "../../container/dashboardWrapper"
import { StyledContainer, StyledContent, StyledMainContentWrapper, StyledTopWrapper, StyledNextPageDiv, StyledNextPageDivContainer } from "../../styles/examination"

import {
    MdAssessment,
    MdHelpOutline,
    MdTimer
} from "react-icons/md";
import {
    IoDownloadOutline
} from "react-icons/io5";
import { QuestionsStepper } from '../../components/questions-stepper'
import { examInstructions } from '../../services/examData'
import { Link } from 'react-router-dom';
import { Breadcrumb } from '../../components/breadcrumb/breadcrumb';

const AssignmentInstructions = () => {
    return (
        <DashboardWrapper>
            <StyledTopWrapper>
                <StyledContainer>
                    <StyledContent>
                        <Breadcrumb
                            crumbs={['assignments', 'English Language']}
                        />
                        <div className="top">
                            <h1 className="subject-title">English Language</h1>
                        </div>
                        <div className="bottom">
                            <p className='exam-text'>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Turpis in eu mi bibendum neque egestas congue quisque egestas. In fermentum posuere urna nec tincidunt praesent semper feugiat. Augue mauris augue neque gravida in. Quam viverra orci sagittis eu volutpat odio facilisis mauris.</p>
                        </div>
                        <div className="download-assignment-btns" style={{ marginTop: '3rem' }}>
                            <Button variant="secondary">download assignment <IoDownloadOutline className="download-assignment-icon" /></Button>
                            <Link to="/student/assignments/submit">
                                <Button variant="secondary">submit assignment</Button>
                            </Link>
                        </div>
                    </StyledContent>
                </StyledContainer>
            </StyledTopWrapper>
            <StyledNextPageDiv>
                <StyledNextPageDivContainer>
                    <div className="score-icon-div">
                        <div className="check-icon-container">
                            <MdHelpOutline />
                        </div>
                        <span>15 Questions</span>
                    </div>
                    <div className="class-icon-div">
                        <div className="check-icon-container">
                            <MdTimer />
                        </div>
                        <span>Due on Feb 24 </span>
                    </div>
                    <div className="class-icon-div">
                        <div className="check-icon-container">
                            <MdAssessment />
                        </div>
                        <span>JSS 1</span>
                    </div>
                </StyledNextPageDivContainer>
            </StyledNextPageDiv>
            <StyledMainContentWrapper>
                <StyledContainer>
                    <QuestionsStepper instructions={examInstructions} />
                </StyledContainer>
            </StyledMainContentWrapper>

        </DashboardWrapper >
    )
}

export default AssignmentInstructions
